// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
const deps = [
  require('config').name,
  require('vendor/lodash').name,
  require('data/service/accountService').name,
  require('data/service/location').name,
  require('data/service/timeoutWarningService').name,
  require('data/service/apolloService').name,
  require('data/actions/auth').name,
  require('data/util/fullScreenConfirmDialogService').name,
];

module.exports = angular
  .module('bench.data.util', deps)
  .factory('Api', require('./api'))
  .factory('MainApi', require('./mainApi'))
  .factory('BookkeepingApi', require('./bookkeepingApi'))
  .factory('ReportsApi', require('./reportsApi'))
  .factory('FdsApi', require('./fdsApi'))
  .factory('GatewayApi', require('./gatewayApi'))
  .factory('FtApi', require('./ftApi'))
  .factory('CategorizerApi', require('./categorizerApi'))
  .factory('LocalStorageStore', require('./localStorageStore'))
  .factory('Store', require('./store'))
  .factory('Relation', require('./relation'))
  .factory('Memoize', require('./memoize'))
  .factory('Model', require('./model'))
  .factory('AvatarUrl', require('./avatarUrl'))
  .factory('Collection', require('./collection'))
  .factory('ViewModel', require('./viewModel'))
  .factory('Validate', require('./validate'))
  .factory('Uuid', require('./uuid'))
  .factory('GravatarUrl', require('vendor/gravatar/gravatarUrl.js'))
  .constant('url', require('url'))
  .constant('path', require('path'))
  .constant('dateFunctions', require('./dateFunctions'));
